import { showRequestError } from '../../utils/request-feedback';
import { PermissionControl } from '../../permissions/access';
import { useEffect, useState } from 'react';
import { createInviteCode, deleteInviteCode, getInviteCode, updateInviteCode } from "../../api/system";
import { Table, message, Typography, Flex, Button, Popconfirm } from 'antd';
import { getRootUrl } from '../../utils/base_url';


const InviteCodeView = () => {
    const tabCols = [
        {
            title: 'Index',
            dataIndex: 'id',
            key: 'id',
            render: (text, _, index) => (index + 1),
        },
        {
            title: 'Code',
            dataIndex: 'inviteCode',
            key: 'inviteCode',
            render: (text, record) => {
                let val = record.inviteCode;
                return <PermissionControl permission="configsetting.control.inline.6cda8404" actionOnly variant={Number(record.id) > 0 ? 'update' : 'create'}><Typography.Text editable={
                    {
                        onChange: (value) => {
                            val = value;
                        },
                        onEnd: () => {
                            editHandle(Number(record.id) > 0 ? { id: record.id, inviteCode: val } : { ...record, inviteCode: val });
                        }
                    }
                }>{text}</Typography.Text></PermissionControl>
            },
            width: '20%',
        },
        {
            title: 'Total Quota',
            dataIndex: 'total',
            key: 'total',
            render: (text, record) => {
                let val = record.total;
                return <PermissionControl permission="configsetting.control.inline.50349b62" actionOnly variant={Number(record.id) > 0 ? 'update' : 'create'}><Typography.Text editable={
                    {
                        onChange: (value) => {
                            val = value;
                        },
                        onEnd: () => {
                            editHandle(Number(record.id) > 0 ? { id: record.id, total: val } : { ...record, total: val });
                        }
                    }
                }>{text}</Typography.Text></PermissionControl>
            },
            width: '20%',
        },
        {
            title: 'Platform',
            dataIndex: 'platform',
            key: 'platform',
            render: (text, record) => {
                let val = record.platform;
                return <PermissionControl permission="configsetting.control.inline.bd9f4852" actionOnly variant={Number(record.id) > 0 ? 'update' : 'create'}><Typography.Text editable={
                    {
                        onChange: (value) => {
                            val = value;
                        },
                        onEnd: () => {
                            editHandle(Number(record.id) > 0 ? { id: record.id, platform: val } : { ...record, platform: val });
                        }
                    }
                }>{text}</Typography.Text></PermissionControl>
            },
        },
        {
            title: 'Used Quota',
            dataIndex: 'used',
            key: 'used',
        },
        {
            title: 'Referral Link',
            dataIndex: 'inviteCode',
            key: 'inviteCode',
            render: (text, record) => {
                let val = record.inviteCode;
                return <Typography.Text copyable>{`${getRootUrl()}/referral?code=${text}`}</Typography.Text>
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <Button.Group size='small'>
                        <PermissionControl permission="configsetting.control.deleteHandle.7279938a"><Popconfirm
                            title="Delete Action"
                            description="Are you sure to delete this invite code?"
                            onConfirm={() => { deleteHandle(record) }}
                            okText="Yes"
                            cancelText="No" >
                            <Button danger type='link'>Delete</Button>
                        </Popconfirm></PermissionControl>
                    </Button.Group>
                )
            }
        }
    ];

    const [tabData, setTabData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setLoading(true);
        getInviteCode({'page.disable': true}).then(res => {
            if (res.list) {
                setTabData(res.list);
            }
        }).finally(() => setLoading(false)).catch(showRequestError)
    }

    const deleteHandle = (item) => {
        if(parseInt(item.id) <= 0) {
            setTabData([...tabData].filter(old => old !== item));
            return;
        }
        setLoading(true);
        deleteInviteCode(item.id).then(res => {
            if(res) {
                message.success('deleted!');
                setLoading(false);
                fetchData();
            }
        }).catch((err) => {
            showRequestError(err, err?.message);
            setLoading(false);
        })
    }

    const editHandle = (params) => {
        setLoading(true);
        if(parseInt(params.id) > 0) {
            updateInviteCode(params).then(res => {
                if(res) {
                    message.success('updated!');
                    fetchData();
                }
            }).catch(err => {
                fetchData();
            }).finally(() => setLoading(false));
        } else {
            let newParams = {...params};
            delete newParams['id'];
            createInviteCode(newParams).then(res => {
                if(res) {
                    message.success('created!');
                    fetchData();
                }
            }).catch(err => {
                fetchData();
            }).finally(() => setLoading(false));
        }
        
    }

    const addNewInviteCode = () => {
        if(tabData.findIndex(item => item.id === '-1') >= 0) return;
        setTabData([
            {
                id: '-1',
                inviteCode: '',
                platform: '',
            }, ...tabData
        ]);
    }

    return (
        <div>
            <Flex justify='flex-end' style={{paddingBottom: 20, marginRight: 20}}>
                <PermissionControl permission="configsetting.control.button.47409efd"><Button type='primary' onClick={addNewInviteCode}>Add New InviteCode</Button></PermissionControl>
            </Flex>
            <Table
                scroll={{ x: true }}
                loading={loading}
                rowKey={(record) => record.id}
                rowClassName={'table-row'}
                size='small'
                dataSource={tabData}
                columns={tabCols}
                pagination={false} />
        </div>
    )
}

export default InviteCodeView;